import React,{useState, useContext, useEffect} from 'react';

import {  
  Card,  
  Button,
  Row,
  Col,
  Modal,
  Form,
  Alert
} from 'react-bootstrap';
import axios from 'axios';
import _ from 'lodash';

import AskTitle from './AskTitle';
import UserContext from '../../contexts/UserContext';

import Utils from '../../Utils';
import { MessageModal } from '../../components';

const Step1 = (props) => {

  const [mode,setMode] = useState(0);
  const udata = Utils.getUserData();
  const [message, setMessage] = useState(false);
  const [draft, setDraft] = useState(false);
  const [stepData, setStepData] = useState(_.get(udata, `stepData${udata.id}`, {step:1}));  
  const {loadDraft, deleteDraft, checkPkgValidity,thirdPUserData} = useContext(UserContext);
  
  const modeAry = [
    "",
    "Convert Your PDF/PPT to SVASU",
    "Create Your Video-based SVASU",
    "Build Your Own Customized SVASU"
  ];

  const startNow = (num) => (e) => {
    
    const isAllowed = (validity) => {      
      
      if(!validity.validity) Utils.confirmBuyNow(validity.message);
      else setMode(num);
    }

    checkPkgValidity(isAllowed);
    
  }

const checkDraft = () => {  
    axios.get(Utils.apiUrl('Draft/checkUserDraft'), Utils.apiHeaders())
      .then(res => {
          if(res.data.success){
            setDraft(res.data.data);
          }
        }
      )
      .catch(err => console.log("Draft check error : ", err));
}

  useEffect(checkDraft, []);

  const getDraft = () => {
    
    const isAllowed = (validity) => {
      
      if(!validity.validity) Utils.confirmBuyNow(validity.message);
      else loadDraft();
    }

    checkPkgValidity(isAllowed);
    
  }

  const delDraft = () => {
    if(window.confirm("Are you sure to delete this draft permanently?")){      
      deleteDraft((success, msg) => {
        if(success){
          setMessage([success ?  'info' : 'error' , msg]);
          setDraft(false);
        } 
      });      
    }
  }
  
  const modeCard = (m) => {
    return <Card className="card-box h-100">
      <Card.Body className="p-5">        
        <h3 className="my-2">{modeAry[m]}</h3>
        
        {m===1 && <p>
          Upload your PDF / PPT to generate slides. Use them as they are OR customize them later to build a SVASU package.
        </p>}

        {m===2 && <p>
          Create interactive learning from your existing videos.
        </p>}

        {m===3 && <p>          
          Build your SVASU using our sample slide tools, tune and publish them.
        </p>}

      </Card.Body>  
      <Card.Footer className="text-center"><Button className="active px-5 py-2" onClick={startNow(m)}>Start Now</Button></Card.Footer>
    </Card>
  }
  
  return <>
 {thirdPUserData.from}
    <div className="heading mb-4">Let's Get Started! Build Your Course.</div>
    <div className="home3step">
    {draft  && <Row className="my-2 draft">      
        <h3>You have saved the draft. 
          <span className="clickable" onClick={getDraft} > Continue with the draft /</span>
          <span className="clickable" onClick={delDraft} > Discard the draft?</span>
        </h3>
    </Row>}
    <Row>
      <Col className="mt-3">{modeCard(1)}</Col>
      <Col className="mt-3">{modeCard(2)}</Col>
      <Col className="mt-3">{modeCard(3)}</Col>
    </Row>
    </div>
    {mode >= 1 && <AskTitle onHide={() => setMode(0)} mode={mode} onSuccess={(sprops) => {props.onContinue(mode, sprops)}} />}
    {message && <MessageModal type={message[0]}  message={message[1]} onHide={() => { setMessage(false); }} />}
  </>;
}

export default Step1;